let Components = {};

Components['DialogFormSales'] = require('../../app/routes/MasterSales/DialogForm').default;
Components['DialogFormVehicleLicense'] = require('../../app/routes/MasterVehicleLicense/DialogForm').default;
Components['DialogFormDriverLicense'] = require('../../app/routes/MasterDriverLicense/DialogForm').default;
Components['DialogFormArea'] = require('../../app/routes/MasterArea/DialogForm').default;
Components['DialogFormBusinessType'] = require('../../app/routes/MasterBusinessType/DialogForm').default;
Components['DialogFormCountry'] = require('../../app/routes/MasterCountry/DialogForm').default;
Components['DialogFormCustomer'] = require('../../app/routes/MasterCustomer/DialogForm').default;
Components['DialogFormMeasurement'] = require('../../app/routes/MasterMeasurement/DialogForm').default;
Components['DialogFormVehicleType'] = require('../../app/routes/MasterVehicleType/DialogForm').default;
Components['DialogFormVendor'] = require('../../app/routes/MasterVendor/DialogForm').default;
Components['DialogFormDriver'] = require('../../app/routes/MasterDriver/DialogAdd').default;
Components['DialogFormVehicle'] = require('../../app/routes/MasterVehicle/DialogAdd').default;
Components['DialogFormGeofence'] = require('../../app/routes/MasterGeofence/DialogForm').default;
Components['DialogFormPool'] = require('../../app/routes/MasterPool/DialogForm').default;
Components['DialogFormCustomerPoint'] = require('../../app/routes/CustomerPoint/DialogForm').default;
Components['DialogFormCompany'] = require('../../app/routes/MasterCompany/DialogForm').default;
Components['DialogFormPoolGroup'] = require('../../app/routes/MasterPoolGroup/DialogForm').default;
Components['DialogFormCustomerPointGroup'] = require('../../app/routes/GroupCustomerPoint/DialogForm').default;
Components['DialogFormUser'] = require('../../app/routes/MasterUser/DialogUser').default;
Components['DialogFormFuel'] = require('../../app/routes/MasterFuel/DialogForm').default;
Components['DialogFormWorkShop'] = require('../../app/routes/MasterWorkShop/DialogForm').default;
// Components['Component2'] = require('./Component2').default;
// Components['Component3'] = require('./Component3').default;

export default Components


// WEBPACK FOOTER //
// ./components/InputVirtual/ComponentIndex.js